import React from 'react';
import { isBefore } from 'date-fns';

import { getDateFormat } from 'helpers/helper';

type Props = {
  cancelDate: string;
};

const SubscriptionCancelDate: React.FC<Props> = ({ cancelDate }) => (
  <span
    style={{
      color: 'var(--color-gray-75)',
      fontSize: 12,
    }}
  >{`${
      isBefore(new Date(cancelDate), new Date())
        ? 'Canceled'
        : 'Cancels'
    } ${getDateFormat(new Date(cancelDate))}`}</span>
);

export default SubscriptionCancelDate;
